import { render, staticRenderFns } from "./BubbleButtonContents.vue?vue&type=template&id=6fac5f98&scoped=true&"
import script from "./BubbleButtonContents.vue?vue&type=script&lang=js&"
export * from "./BubbleButtonContents.vue?vue&type=script&lang=js&"
import style0 from "./BubbleButtonContents.vue?vue&type=style&index=0&id=6fac5f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fac5f98",
  null
  
)

export default component.exports